export default {
  title_one: 'Aktualizacja statystyk dla „{{title}}"',
  title_few: 'Statystyki dostarczenia są aktualizowane dla {{count}} kampanii',
  title_many: 'Statystyki dostarczenia są aktualizowane dla {{count}} kampanii',
  title_other: 'Aktualizacja statystyk dla {{count}} kampanii',
  subtitle_pending:
    'Apple i Google potwierdzają odbiór za ok. {{minutes}}m {{seconds}}s (ok. {{time}}). Statystyki odświeżą się automatycznie.',
  subtitle_ready: 'Potwierdzenia powinny być dostępne. Odśwież stronę, aby zobaczyć najnowsze dane dostarczenia.',
};
